var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTdhDisabledDarkMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.158.028c.474.481.76 1.145.76 1.872 0 .789-.34 1.5-.88 1.99a4.204 4.204 0 0 1 3.145 4.067 4.19 4.19 0 0 1-3.607 4.145 1.914 1.914 0 0 0 .259 3.809H8.956A8.002 8.002 0 0 0 16 7.974c.008-4.02-2.976-7.36-6.842-7.942V.028Z",
  fill: "#737474"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M6.842 15.883a2.661 2.661 0 0 1-.76-1.872c0-.789.339-1.5.88-1.99a4.204 4.204 0 0 1-3.145-4.068A4.19 4.19 0 0 1 7.424 3.81 1.914 1.914 0 0 0 7.165 0H7.044A8.002 8.002 0 0 0 0 7.937c-.008 4.02 2.976 7.36 6.842 7.942v.004Z",
  fill: "#737474"
})));
export default SvgTdhDisabledDarkMode;